exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._6L8I4DoayUEqvFeZ9_4gR{-webkit-box-shadow:0 -17px 0 -16px var(--themePrimary);box-shadow:0 -17px 0 -16px var(--themePrimary)}._3GXbXu8ZrDpUYJxp-jkywu{opacity:.5}._3E3ptltnOSpLgJfeJrGb2x{width:250px;max-width:250px}html[dir] ._3E3ptltnOSpLgJfeJrGb2x{border:1px solid var(--neutralTertiaryAlt);background:var(--neutralQuaternaryAlt)}._3cZg3UMBbrn8retf-HkgLi{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--black)}html[dir] ._1ouhWsuUiIy_iYvkprYvaK{border-color:var(--neutralSecondary)}", ""]);
// Exports
exports.locals = {
	"topBorderDragOver": "_6L8I4DoayUEqvFeZ9_4gR",
	"isBeingDragged": "_3GXbXu8ZrDpUYJxp-jkywu",
	"dragHelperStyle": "_3E3ptltnOSpLgJfeJrGb2x",
	"dragTextWrapper": "_3cZg3UMBbrn8retf-HkgLi",
	"dragCheckboxClassName": "_1ouhWsuUiIy_iYvkprYvaK"
};